// Shared board surface and mode-specific workspace content slot.
import type { ReactNode } from 'react';
import { Board } from '../../board/Board';
import type { BoardMap, PieceCode } from '../../board/pieces';
import type { Role, RoomState } from '../../types';

type BoardWorkspaceProps = {
  children?: ReactNode;
  role: Role;
  roomId: string;
  state: RoomState | null;
  board: BoardMap;
  orientation: 'white' | 'black';
  animationVersion: number;
  selected: string | null;
  interactive: boolean;
  recording: boolean;
  spare: PieceCode | null;
  onRemovePiece: (square: string) => void;
  onSquareClick: (square: string) => void;
  onDropPiece: (from: string, to: string) => void;
  onSparePiece: (piece: PieceCode) => void;
  onRotate: () => void;
  onArrow: (from: string, to: string) => void;
  onHighlight: (square: string) => void;
  onClearGraphics: () => void;
};

export function BoardWorkspace({
  children,
  role,
  roomId,
  state,
  board,
  orientation,
  animationVersion,
  selected,
  interactive,
  recording,
  spare,
  onRemovePiece,
  onSquareClick,
  onDropPiece,
  onSparePiece,
  onRotate,
  onArrow,
  onHighlight,
  onClearGraphics
}: BoardWorkspaceProps) {
  return (
    <section className="board-column">
      <div className="board-card">
        <Board
          board={board}
          orientation={orientation}
          animationVersion={animationVersion}
          selectedSquare={selected}
          interactive={interactive}
          graphicsInteractive={role === 'trainer' && Boolean(roomId)}
          sparePieces={role === 'trainer' && state?.mode === 'lecture' && !recording}
          sparePiecesLayout={role === 'trainer' && Boolean(roomId)}
          selectedSpare={spare}
          onRemovePiece={onRemovePiece}
          arrows={state?.arrows}
          highlights={state?.highlights}
          onSquareClick={onSquareClick}
          onDropPiece={onDropPiece}
          onSparePiece={onSparePiece}
          onArrow={onArrow}
          onHighlight={onHighlight}
        />
        <div className="board-controls">
          <div className="board-controls-main">
            <button className="icon-button" aria-label="Перевернуть доску" title="Перевернуть доску" onClick={onRotate}>
              <span className="rotate-board-icon" aria-hidden="true" />
            </button>
          </div>
          {role === 'trainer' && roomId && (
            <div className="graphics-controls">
              <span className="graphics-hint">ПКМ по клетке — выделить · ПКМ с перетаскиванием — стрелка</span>
              <button className="ghost" onClick={onClearGraphics}>Очистить графику</button>
            </div>
          )}
        </div>
      </div>
      {children}
    </section>
  );
}
